import { Box, Button, Container, Theme, Typography } from "@mui/material";
import { useTranslations as t } from "@/core/hooks/useTranslations/useTranslations";
import { ButtonVariant, HeadingLevel } from "@/core/types/types";
import useCustomStyles from "@/core/hooks/useCustomStyles/useCustomStyles";
import { useContext, useState } from "react";
import { ConfigContext } from "@/core/contexts/ConfigContext";
import { camundaApi } from "@/core/api/camundaApi";
import { Loading } from "@/core/components/Loading/Loading";

const styles = (theme: Theme) => ({
  root: {
    display: "flex",
    gap: theme.spacing(2),
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  buttons: {
    width: "100%",
    maxWidth: "456px",
    textTransform: "inherit",
  },
});

const UnsubscribeErrorAction = () => {
  const classes: any = useCustomStyles(styles);

  const initializationConfig = useContext(ConfigContext);

  const [isRetryable, setIsRetryable] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const handleCancelRetry = async (): Promise<void> => {
    if (initializationConfig.processId) {
      try {
        setIsLoading(true);
        const response = await camundaApi.unsubscribe(
          initializationConfig.processId,
          initializationConfig.utm_campaign
        );
        if (!response.ok) {
          setIsRetryable(false);
        }
        setIsLoading(false);
      } catch (e) {
        setIsLoading(false);
      }
    }
  };

  return (
    <Container sx={classes?.root}>
      {isLoading ? (
        <Box sx={{ display: "flex", alignSelf: "center", marginTop: "70px" }}>
          <Loading />
        </Box>
      ) : (
        <>
          <Typography variant={HeadingLevel.H1}>{t("error.title")}</Typography>
          <Typography variant={HeadingLevel.Body2} fontWeight={400}>
            {isRetryable
              ? t("error.subtitle")
              : t("error.unsubscribe.subtitle")}
          </Typography>
          <Typography fontSize={64}>
            {isRetryable ? <>😔</> : <>😞</>}
          </Typography>
          {isRetryable && (
            <>
              <Button
                sx={classes?.buttons}
                onClick={handleCancelRetry}
                variant={ButtonVariant.Contained}
              >
                {t("error.btn.reload.label")}
              </Button>
            </>
          )}
        </>
      )}
    </Container>
  );
};

export default UnsubscribeErrorAction;
